import axios from "axios";
import LoginUserForm from "./LoginUserForm";
import LoginResponse from "./LoginResponse";
import UserApiRoute from "user/UserApiRoute";
import LoginUserWithPhoneForm from "./LoginUserWithPhoneForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import ForgotPasswordSession from "./ForgotPasswordSession";
import ResetPasswordCodeRequest from "./ResetPasswordCodeRequest";
import CreateNewPasswordRequest from "./CreateNewPasswordRequest";

export default class AuthApi {
  async login(form: LoginUserForm): Promise<LoginResponse> {
    try {
      const response = await axios.post<LoginResponse>(
        UserApiRoute.LOGIN_WITH_EMAIL,
        form,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async loginWithPhone(form: LoginUserWithPhoneForm): Promise<LoginResponse> {
    try {
      const response = await axios.post<LoginResponse>(
        UserApiRoute.LOGIN_WITH_PHONE,
        form,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async createForgotPasswordSession(
    form: ForgotPasswordForm
  ): Promise<ForgotPasswordSession> {
    const response = await axios.post(UserApiRoute.FORGOT_PASSWORD, form, {
      withCredentials: true,
    });
    return response.data;
  }

  sendResetPasswordCode(form: ResetPasswordCodeRequest) {
    return axios.post(UserApiRoute.FORGOT_PASSWORD_CODE, form, {
      withCredentials: true,
    });
  }

  resetPassword(form: CreateNewPasswordRequest): Promise<void> {
    return axios.post(UserApiRoute.RESET_PASSWORD, form, {
      withCredentials: true,
    });
  }
}
